export default __webpack_public_path__ + "static/mobile-home-image-6bfb3a46f3bdf87fa217b36ac643dec7.jpg";